// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
    width: 100%;
}

.admin-container {
    width: 100%;
    overflow-y: scroll;
    padding: 0 0 150px;
    height: 88vh;
}

.containerGoAdmin {
    width: 100%;
    background-color: #181b25;
    position: sticky;
    top: 0;
    z-index: 10;
}

.containerGoAdmin .goAdmin {
    margin: 0 0 25px;
    padding-top: 5px;
    padding-bottom: 5px;
}

.goAdmin i {
    margin-right: 8px;
}

.admin-container ul {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    padding: 0;
}

.admin-container ul li {
    width: 32%;
    margin-bottom: 25px;
    list-style: none;
}

.admin-container ul li button {
    padding: 15px 8px;
    min-height: 80px;
}

@media (max-width: 500px) {
    .admin-container ul {
        padding: 5px !important;
    }

    .admin-container ul li {
        width: 100%;
    }
}

.layout-container {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: flex-start;
}

.layout-container .dropdown-container {
    flex: 1 1 calc(33.33% - 20px);
    max-width: calc(33.33% - 20px);
    border: orange 2px solid;
    border-radius: 8px;
    background: #000;
    color: #fff;
    position: relative;
    box-sizing: border-box;
    cursor: pointer;
}

.toggle-button {
    display: flex;
    width: 100%;
    padding: 20px;
    font-size: 1rem;
    text-align: center;
    justify-content: space-between;
}

.toggle-button:hover {
    background-color: #333;
    border-radius: 8px;
}

.layout-container #options {
    position: absolute;
    width: 100%;
    background: #fff;
    padding: 10px 15px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    border-radius: 8px;
    left: 0;
    top: 64px;
    z-index: 1;
}

/* For iPad screens (typically 768px width) */
@media screen and (max-width: 1024px) {
    .layout-container .dropdown-container {
        flex: 1 1 calc(50% - 20px);
        max-width: calc(50% - 20px);
    }
}

/* For mobile screens (typically 576px and below) */
@media screen and (max-width: 576px) {
    .layout-container .dropdown-container {
        flex: 1 1 100%;
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/components/admin/admin.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,MAAM;IACN,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,UAAU;AACd;;AAEA,6CAA6C;AAC7C;IACI;QACI,0BAA0B;QAC1B,2BAA2B;IAC/B;AACJ;;AAEA,mDAAmD;AACnD;IACI;QACI,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":[":host {\n    width: 100%;\n}\n\n.admin-container {\n    width: 100%;\n    overflow-y: scroll;\n    padding: 0 0 150px;\n    height: 88vh;\n}\n\n.containerGoAdmin {\n    width: 100%;\n    background-color: #181b25;\n    position: sticky;\n    top: 0;\n    z-index: 10;\n}\n\n.containerGoAdmin .goAdmin {\n    margin: 0 0 25px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n}\n\n.goAdmin i {\n    margin-right: 8px;\n}\n\n.admin-container ul {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    flex-wrap: wrap;\n    padding: 0;\n}\n\n.admin-container ul li {\n    width: 32%;\n    margin-bottom: 25px;\n    list-style: none;\n}\n\n.admin-container ul li button {\n    padding: 15px 8px;\n    min-height: 80px;\n}\n\n@media (max-width: 500px) {\n    .admin-container ul {\n        padding: 5px !important;\n    }\n\n    .admin-container ul li {\n        width: 100%;\n    }\n}\n\n.layout-container {\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    justify-content: flex-start;\n}\n\n.layout-container .dropdown-container {\n    flex: 1 1 calc(33.33% - 20px);\n    max-width: calc(33.33% - 20px);\n    border: orange 2px solid;\n    border-radius: 8px;\n    background: #000;\n    color: #fff;\n    position: relative;\n    box-sizing: border-box;\n    cursor: pointer;\n}\n\n.toggle-button {\n    display: flex;\n    width: 100%;\n    padding: 20px;\n    font-size: 1rem;\n    text-align: center;\n    justify-content: space-between;\n}\n\n.toggle-button:hover {\n    background-color: #333;\n    border-radius: 8px;\n}\n\n.layout-container #options {\n    position: absolute;\n    width: 100%;\n    background: #fff;\n    padding: 10px 15px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    border-radius: 8px;\n    left: 0;\n    top: 64px;\n    z-index: 1;\n}\n\n/* For iPad screens (typically 768px width) */\n@media screen and (max-width: 1024px) {\n    .layout-container .dropdown-container {\n        flex: 1 1 calc(50% - 20px);\n        max-width: calc(50% - 20px);\n    }\n}\n\n/* For mobile screens (typically 576px and below) */\n@media screen and (max-width: 576px) {\n    .layout-container .dropdown-container {\n        flex: 1 1 100%;\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
